import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To replace any type of `}<inlineCode parentName="p">{`UIView`}</inlineCode>{` with a redacted version in the replay, set the `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uiaccessibilityidentification/1623132-accessibilityidentifier"
      }}>{`accessibilityIdentifier`}</a>{` to `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let imvProfilePhoto = UIImageView(frame: CGRect(x: 50, y: 50, width: 100, height: 100))
imvProfilePhoto.accessibilityIdentifier = "ph-no-capture"
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` For SwiftUI please refer to the `}<a parentName="p" {...{
          "href": "#masking-in-swiftui"
        }}>{`Masking in SwiftUI`}</a>{` section below`}</p>
    </blockquote>
    <h3 {...{
      "id": "masking-in-swiftui"
    }}>{`Masking in SwiftUI`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`When using the `}<a parentName="p" {...{
            "href": "https://developer.apple.com/documentation/swiftui/textfield"
          }}>{`SwiftUI TextField`}</a>{` with `}<a parentName="p" {...{
            "href": "https://developer.apple.com/documentation/uikit/uitextinputtraits"
          }}>{`UITextInputTraits`}</a>{`, setting traits such as `}<inlineCode parentName="p">{`TextField("Email", text: ...).keyboardType(.emailAddress)`}</inlineCode>{` will always be automatically masked since it's for private text.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The `}<a parentName="p" {...{
            "href": "https://developer.apple.com/documentation/swiftui/securefield"
          }}>{`SwiftUI SecureField`}</a>{` view is always automatically masked.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can manually mark a SwiftUI View for masking using the `}<inlineCode parentName="p">{`postHogMask()`}</inlineCode>{` view modifier:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-swift"
          }}>{`// This view (and children) will *always* be masked in session replay recordings
MyCoolView()
  .postHogMask()
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The `}<inlineCode parentName="p">{`postHogNoMask()`}</inlineCode>{` view modifier can be used to prevent a view from being masked in session recordings, regardless of any default masking behavior:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-swift"
          }}>{`// This view (and children) will *never* be masked in session replay recordings
MyCoolView()
  .postHogNoMask()
`}</code></pre>
      </li>
    </ul>
    <h3 {...{
      "id": "handling-sensitive-third-party-screens"
    }}>{`Handling sensitive third-party screens`}</h3>
    <p>{`Third-party components (like payment forms or authentication screens) are often rendered in separate view hierarchies that can't be accessed or modified for masking.`}</p>
    <p>{`For these cases, manually controlling the recording state is the only reliable solution. For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ios_swift"
      }}>{`// Stop session recording before showing a third-party payment sheet
PostHogSDK.shared.stopSessionRecording()

// Present third-party payment sheet
presentPaymentSheet()

// ... 
// Some time later when the sheet is dismissed, resume recording
PostHogSDK.shared.startSessionRecording()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      